import React from 'react';
import { motion } from 'framer-motion';
import { HiUser, HiAcademicCap, HiLocationMarker, HiMail } from 'react-icons/hi';
import resumeDoc from '../Balaji_Iyer_Resume.docx';

const About: React.FC = () => {
  const personalInfo = [
    { icon: HiUser, label: 'Name', value: 'Balaji Iyer' },
    { icon: HiLocationMarker, label: 'Location', value: 'Brisbane, Australia' },
    { icon: HiMail, label: 'Email', value: 'balajiiyer29@gmail.com' },
    { icon: HiAcademicCap, label: 'Degree', value: 'Bachelor of Engineering (Computer)' },
  ];

  return (
    <section id="about" className="section-padding bg-white">
      <div className="container-custom">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-bold text-dark-900 mb-4">About Me</h2>
          <p className="text-lg text-dark-600 max-w-2xl mx-auto text-left">
            Hi, I'm Balaji! I love turning ideas into real, working software that people enjoy using. Over the past 13+ years, I've helped businesses and government teams solve tough problems with technology—whether that's building a new web app, making systems run faster, or guiding a team through a big project. As a full stack web developer, I work with .NET, Java, and all the latest JavaScript frameworks. I'm experienced with modern UI frameworks like Angular, React, Svelte, Aurelia, and Bootstrap, building seamless user experiences from front end to back end. My focus is always on making things simple, reliable, and user-friendly. If you need someone who cares about quality and loves a challenge, let's connect!
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Personal Information */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="space-y-6"
          >
            <h3 className="text-2xl font-semibold text-dark-900 mb-6">Personal Information</h3>
            
            <div className="space-y-4">
              {personalInfo.map((info, index) => (
                <motion.div
                  key={info.label}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  viewport={{ once: true }}
                  className="flex items-center space-x-4"
                >
                  <div className="w-10 h-10 bg-primary-100 rounded-lg flex items-center justify-center">
                    <info.icon className="text-primary-600" size={20} />
                  </div>
                  <div>
                    <p className="text-sm text-dark-500 font-medium">{info.label}</p>
                    <p className="text-dark-900">{info.value}</p>
                  </div>
                </motion.div>
              ))}
            </div>

            {/* Download CV Button */}
            <div className="pt-4">
              <a
                href={resumeDoc}
                download="Balaji_Iyer_Resume.docx"
                className="btn-primary"
              >
                Download Full CV
              </a>
            </div>
          </motion.div>

          {/* About Content */}
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="space-y-6"
          >
            <h3 className="text-2xl font-semibold text-dark-900">Education & Certifications</h3>
            <div className="space-y-4 text-dark-600 leading-relaxed">
              <ul className="list-disc ml-6">
                <li>Certified Scrum Master - 2023</li>
                <li>Microsoft Certification in Azure Fundamentals, Adelaide - 2022</li>
                <li>Microsoft Certification in Web Application Development, .Net framework 4.0, India - 2012</li>
                <li>Bachelor of Engineering (Computer), Pillai’s Institute of Information Technology, Mumbai, India - 2011</li>
              </ul>
            </div>

            {/* Key Highlights */}
            <div className="grid grid-cols-2 gap-4 pt-4">
              <div className="text-center p-4 bg-primary-50 rounded-lg">
                <div className="text-2xl font-bold text-primary-600">13+</div>
                <div className="text-sm text-dark-600">Years Experience</div>
              </div>
              <div className="text-center p-4 bg-primary-50 rounded-lg">
                <div className="text-2xl font-bold text-primary-600">10+</div>
                <div className="text-sm text-dark-600">Projects Completed</div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About; 